export default __webpack_public_path__ + "media/images/user_photos/114-7d3351065adb37bd96083a0aaab242d5.jpg";